import React from 'react';
import Header from '../JobPage/Header';
import SearchBar from '../JobPage/SearchBar';
import JobFilters from '../JobPage/JobFilters';
import JobList from './JobList';
import Footer from '../JobPage/Footer';
import { useParams } from 'react-router-dom';
import { Container } from '@/Components/ui/container';
import { Stack } from '@/Components/ui/layout';
import { Inline } from '@/Components/ui/layout';

const JobsPage = () => {
  const { compnayId } = useParams();

  return (
    <div className="bg-background text-foreground min-h-screen flex flex-col">
      <Header />
      <Container size="default" className="flex-1">
        <Stack spacing="lg">
          <SearchBar />
          <Inline spacing="md" align="start" className="mt-[59px]">
            <JobFilters />
            <JobList companyId={compnayId} />
          </Inline>
        </Stack>
      </Container>
      <Footer />
    </div>
  );
};

export default JobsPage;
